/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PosOnlineStoreApiModel } from './pos-online-store';

export interface OnlineStoreApiModel {
  /**
   * Object active flag
   */
  active?: number;
  /**
   * Additional customer info (optional)
   */
  additional_customer_info?: string;
  /**
   * Users cart expire period in days (optional)
   */
  cart_expire_days?: number;
  /**
   * Order type used in schema
   */
  order_type?: OnlineStoreApiModelOrderTypeEnum;
  /**
   * Payment in store (optional)
   */
  payment_type?: OnlineStoreApiModelPaymentTypeEnum;
  pos_level_store?: PosOnlineStoreApiModel;
  /**
   * Loyalty has active Pos with online-store type
   */
  pos_level_stores_exists?: number;
  /**
   * Terminal ID (optional)
   */
  terminal_id?: string;
  /**
   * Title (optional)
   */
  title?: string;
}
export enum OnlineStoreApiModelOrderTypeEnum {
  OnlineStore = 'online-store',
  FuelTaxi = 'fuel-taxi'
}
export enum OnlineStoreApiModelPaymentTypeEnum {
  None = 'none',
  Bonuses = 'bonuses',
  Possible = 'possible',
  Required = 'required'
}
